require("./myProfileController"); // required here or implicit ??

'use strict';

angular.module('app.myProfile.myProfileDirective', [
    'app.myProfile.myProfileController' // required here or implicit ??
])
.directive('myProfile', [
  function() {
    return {
      restrict: 'EA',
      templateUrl: 'components/myProfile/myProfileDirectiveView.html',
      controller: 'app.myProfile.myProfileController',
      params: {username: null}
    };
  }
]);



// WEBPACK FOOTER //
// ./app.v2/components/myProfile/myProfileDirective.js